<template>
  <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12 m-b">
    <a>
      <section class="panel panel-default m-n media-item">
        <span v-if="isOwner" @click="deleteMedia()" class="pull-right media-delete">
          <a class="btn btn-rounded btn-sm btn-icon btn-danger m-l-sm m-t-sm">
            <i class="fa fa-trash-o icon text-white" title="Delete"></i>
          </a>
        </span>
        <span class="block b-b b-light media-item__image">
          <lazy-img :src="image"></lazy-img>
        </span>
        <span v-if="video" class="m-t-n-md m-r-sm media-type-icon">
          <i class="fa fa-video-camera icon text-danger"></i>
        </span>
        <div class="wrapper">
          <div class="block clear media-title">
            {{media.title}}
          </div>
          <div class="text-sm text-muted m-t-xs media-modified">
            <span><i class="fa fa-clock-o"></i> {{getAgo(media.modified)}} </span>
          </div>
        </div>
      </section>
    </a>
  </div>
</template>

<script>

  import moment from 'moment-timezone';
  import urlParser from 'js-video-url-parser';
  import { loadImage } from "@src/helpers/image-helper";
  import shave from 'shave';

  export default {
    name: "media",
    data() {
      return {
        mediaFile: 'https://ukuya.net/uploads/system/default/media/',
        image: null,
        video: null,
        typeImage: 'image',
        typeVideo: 'video',
        typeDoc: 'doc',
      }
    },
    created() {
      moment.updateLocale('en', {
        relativeTime: {
          future: "in %s",
          past:   "%s ago",
          s:  "%ds",
          m:  "1m",
          mm: "%dm",
          h:  "1h",
          hh: "%dh",
          d:  "1d",
          dd: "%dd",
          M:  "1 month",
          MM: "%d months",
          y:  "1 year",
          yy: "%d years"
        }
      });
      $('.media-delete').click((e) => {
        e.stopPropagation();
      });
    },
    props: {
      isOwner: null,
      media: null
    },
    mounted() {
      this.getImage();
      shave('.media-title', 35, {character: '...'});
    },
    watch: {
      media: function (media) {
        this.media = media;
        this.getImage();
      }
    },
    methods: {
      getImage() {
        if(this.media.type == this.typeDoc) {
          switch (this.media.extension) {
            case 'xls' : this.image = this.mediaFile + 'xls.jpg'; break;
            case 'xlsx' : this.image = this.mediaFile + 'xlsx.jpg'; break;
            case 'ppt' : this.image = this.mediaFile + 'ppt.jpg'; break;
            case 'pptx' : this.image = this.mediaFile + 'pptx.jpg'; break;
            case 'pdf' : this.image = this.mediaFile + 'pdf.jpg'; break;
            default : this.image = this.mediaFile + 'doc.jpg';
          }
        }
        else if(this.media.type == this.typeImage) {
          loadImage(
            this.media.thumbs['thumb-lg'],
            'https://ukuyadev.s3.amazonaws.com/system/blog_default.jpg',
            null,
            src => this.image = src
          );
        }
        else if(this.media.type == this.typeVideo) {
          this.video = urlParser.parse(this.media.url);
          loadImage(
            `https://img.youtube.com/vi/${this.video.id}/hqdefault.jpg`,
            'https://img.youtube.com/vi/default/default.jpg',
            null,
            src => this.image = src
          );
        }
        else this.image = 'https://ukuyadev.s3.amazonaws.com/system/blog_default.jpg';
      },
      getAgo(time) {
        return moment.unix(time).fromNow();
      },
      deleteMedia() {
        this.$emit('deleteMedia', this.media.id);
      }
    }
  }
</script>

<style lang="scss">
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .lazy-image {
    max-width: 100% !important;
  }
  .item_status {
    position: absolute;
    z-index: 99999;
    right: 15px;
  }
  .media-delete {
    position: absolute;
    z-index: 99999;
    color: #fff;
    display: none;
  }
  .media-type-icon {
    position: absolute;
    z-index: 999;
    color: #fff;
    right: 15px;
  }
  .media-title {
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #333333;
    height: 35px;
    text-align: start;
  }
  .media-modified {
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #777777;
  }
  .media-item {
    &:hover {
      .media-delete {
        display: block;
      }
    }
  }
  @import "~@styles/media.scss";

</style>
